import { render, staticRenderFns } from "./VerifiedBrandedProfilePreview.vue?vue&type=template&id=435daf89&scoped=true"
import script from "./VerifiedBrandedProfilePreview.vue?vue&type=script&lang=js"
export * from "./VerifiedBrandedProfilePreview.vue?vue&type=script&lang=js"
import style0 from "./VerifiedBrandedProfilePreview.vue?vue&type=style&index=0&id=435daf89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435daf89",
  null
  
)

export default component.exports